import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}

// Narrow phone viewport (<640px). Used to collapse the two-month date popup
// to a single month so it fits without horizontal cramping on small phones.
export function useIsNarrow() {
  const [isNarrow, setIsNarrow] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: 639px)`)
    const onChange = () => {
      setIsNarrow(window.innerWidth < 640)
    }
    mql.addEventListener("change", onChange)
    setIsNarrow(window.innerWidth < 640)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isNarrow
}
